import React, { useState, useEffect } from "react";
import { Dropdown } from "semantic-ui-react";
import { Location } from "../../../api";
import { useAuth } from "../../../hooks";

const locationController = new Location();

export function SelectLugar({ value, onChange, placeholder = "Seleccionar lugar", fluid = true }) {
  const { accessToken } = useAuth();
  const [options, setOptions]   = useState([]);
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const data = await locationController.getLocations(accessToken);
        setOptions(data.map((l) => ({ key: l._id, value: l._id, text: l.name })));
      } catch {
        setOptions([]);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <Dropdown
      selection
      search
      fluid={fluid}
      clearable
      placeholder={placeholder}
      options={options}
      value={value || ""}
      onChange={(_, d) => onChange(d.value)}
      loading={loading}
    />
  );
}
